import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
const heroSparkImage = "/images/hintsly-gift-hero-spark.jpg";

const HeroSection = () => {
  return (
    <section className="relative w-full max-w-[100vw] overflow-hidden md:min-h-[calc(100vh-80px)] border-t-2 border-destructive">
      <div className="grid md:grid-cols-2 md:min-h-[inherit]">
        <div className="relative z-10 flex items-center px-6 py-16 md:py-20 lg:px-12 xl:px-20">
          <div className="mx-auto w-full max-w-xl md:mx-0">
            <motion.div
              className="mb-6 inline-flex items-center gap-2 px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-primary"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Sparkles className="h-3.5 w-3.5" />
              Premium digital concierge
            </motion.div>

            <h1
              className="text-5xl font-bold leading-[0.95] text-foreground md:text-7xl"
            >
              Give the gift they&apos;ll <span className="text-gradient-brand">actually</span> love.
            </h1>

            <motion.p
              className="mt-6 text-lg leading-relaxed text-foreground/90 md:text-xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.15 }}
            >
              No more fake smiles or unwanted gifts contributing to landfill. Hintsly is the premium digital concierge for beautifully curating your desires and discreetly placing the perfect gift with a bit of spark to the people who matter most.
            </motion.p>

            <motion.div
              className="mt-10"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <Button className="bg-destructive text-destructive-foreground shadow-lg shadow-destructive/20 hover:shadow-xl hover:shadow-destructive/30 hover:brightness-110 active:scale-[0.98] text-base px-8 py-3 rounded-full font-semibold uppercase tracking-[0.18em]" asChild>
                <Link to="/wishlist">Build your free wishlist</Link>
              </Button>
            </motion.div>
          </div>
        </div>

        <motion.div
          className="relative min-h-[360px] overflow-hidden md:-ml-[30%] md:min-h-full"
          initial={{ opacity: 0, x: 24 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <img
            src={heroSparkImage}
            alt="Woman opening a Hintsly gift box in a bright lifestyle scene"
            className="absolute inset-x-0 -top-8 bottom-0 h-[calc(100%+2rem)] w-full object-cover object-[78%_58%]"
            fetchPriority="high"
          />
          {/* Left fade so gold lines are visible but text stays legible */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-1/2 bg-gradient-to-r from-background via-background/70 to-transparent" />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
